import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  theme?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  theme = 'dark',
  size = 'md'
}) => {
  const {
    minutes,
    seconds
  } = useCountdown();
  const bgClass = theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-white text-red-600 border border-red-200';
  const sizeClasses = {
    sm: 'text-sm px-2 py-1',
    md: 'text-lg px-3 py-1.5',
    lg: 'text-2xl px-4 py-2 font-bold'
  };
  return <div className="flex items-center space-x-2 font-mono font-bold" data-id="element-43">
      <div className={`rounded-md shadow-sm flex items-center justify-center ${bgClass} ${sizeClasses[size]}`} data-id="element-44">
        00
      </div>
      <span className={theme === 'dark' ? 'text-white' : 'text-gray-800'} data-id="element-45">
        :
      </span>
      <div className={`rounded-md shadow-sm flex items-center justify-center ${bgClass} ${sizeClasses[size]}`} data-id="element-46">
        {minutes}
      </div>
      <span className={theme === 'dark' ? 'text-white' : 'text-gray-800'} data-id="element-47">
        :
      </span>
      <div className={`rounded-md shadow-sm flex items-center justify-center ${bgClass} ${sizeClasses[size]}`} data-id="element-48">
        {seconds}
      </div>
    </div>;
};